// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { AuthGetString, AuthGetStringAsync } from './types.generated'

const authLocales = [
    'en-US',
    'bn-IN',
    'cs-CZ',
    'de-DE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-IN',
    'es-ES',
    'es-MX',
    'es-US',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'it-IT',
    'ja-JP',
    'kn-IN',
    'ml-IN',
    'mr-IN',
    'nl-NL',
    'pa-IN',
    'pl-PL',
    'pt-BR',
    'ta-IN',
    'te-IN',
    'tr-TR',
    'zh-CN',
] as const
const authBundle = i18nBundle('auth/auth', authLocales)

export const getString: AuthGetString = authBundle.getString
export const getStringAsync: AuthGetStringAsync = authBundle.getStringAsync
